import styled from 'styled-components'
import backgroundDetails from '../../assets/images/backgroundDetails.png'
import { colors } from '../../theme'

export const DivTop = styled.div`
  display: flex;
  align-items: center;
`
export const Span = styled.span`
  margin-left: 15px;
  font-family: 'Sora';
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 140%;
`
export const DivImg = styled.div`
  background: ${colors.surface} url('${backgroundDetails}') no-repeat center
    center;
  border-radius: 24px;
  padding: 20px;
  margin-top: 30px;
  margin-bottom: 30px;
`
export const DivName = styled.div`
  color: ${colors.white};
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 150%;
`
export const SpanData = styled.span`
  display: flex;
  align-items: center;
  gap: 10px;
  color: ${colors.white};
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0.2px;
  margin-top: 10px;
`

export const Div = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  .firstCard {
    width: 41%;
  }
  .secondCard {
    width: 57%;
  }
`
export const Wrapper = styled.div<{ size?: string; alinhamento?: boolean }>`
  width: ${({ size }) => `${size}%`};
  padding: 20px;
  box-shadow: 0px 7px 30px rgba(0, 0, 0, 0.28);
  border-radius: 24px;
  background-color: ${colors.surface};
  align-items: ${({ alinhamento }) => `${alinhamento ? 'end' : 'start'}`};
  display: flex;
  flex-direction: column;
  justify-content: ${({ alinhamento }) =>
    `${alinhamento ? 'space-between' : ''}`};
`
export const DivTablePaginacao = styled.div`
  width: 100%;
`

export const DivButtonHistoricoBaixa = styled.div`
  display: flex;
  flex-direction: column;
  align-items: end;
`
export const IconDismiss = styled.div`
  cursor: pointer;
`
export const LinkWpp = styled.a`
  color: ${colors.white};
  text-decoration: none;
`

export const TypesFilter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px;
  gap: 6px;
  height: 42px;
  font-size: 12px;
  border-radius: 8px;
`

export const FiltersCalendar = styled.button`
  display: flex;
  align-items: center;
  justify-content: left;
  background: none;
  border: none;
  height: 100%;
  width: 100%;
`
export const Calendars = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  font-size: 13px;
`
export const DatePickerStyle = styled.div`
  display: flex;
  justify-content: left;
  align-items: center;
  font-size: 13px;
  font-weight: 700;
  gap: 5px;
  color: ${colors.grey700};
`

export const TitleAndCalendar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`
export const ButtonHistoricoBaixa = styled.label`
  text-decoration: none;
  font-size: 12px;
  font-weight: 500;
  color: ${colors.grey700};
  background-color: ${colors.grey300};
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  padding: 8px 15px;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  width: 190px;
  height: 34px;
  margin-top: 15px;
`

// Barra de filtros do detalhe (produto + periodo da baixa). Mesma linguagem visual da listagem-mae
// (HistoricoBaixa.style), em uma linha so: aqui o cliente ja esta escolhido, entao sobram dois
// filtros e nao cabe o painel suspenso da outra tela.
export const BarraFiltros = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 16px;
  margin-bottom: 20px;
`
export const CampoFiltro = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  font-size: 13px;
  font-weight: 700;
  color: ${colors.grey700};
`
export const AcoesFiltro = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`
export const AvisoRecorte = styled.div`
  font-size: 12px;
  color: ${colors.grey700};
  margin-bottom: 16px;
`
